<template>
  <div>
    <v-card flat class="pa-3" v-if="!signSteps.logged && signSteps.step == 1">
      <div v-if="!twoFactor" class="login-section pa-3">
        <v-layout>
          <span class="login-title"
            >Finalize mais rápido acessando sua conta</span
          >
        </v-layout>
        <v-layout class="mt-3">
          <v-flex>
            <span>{{ userProps.email }}</span>
          </v-flex>
          <v-flex shrink>
            <span class="edit-btn" @click="changeUser">Editar</span>
          </v-flex>
        </v-layout>
        <v-layout class="mt-3">
          <v-flex xs6>
            <v-text-field
              outline
              label="Senha"
              :append-icon="show ? 'visibility' : 'visibility_off'"
              :type="show ? 'text' : 'password'"
              v-model="password"
              @click:append="show = !show"
              :rules="passwordRules"
              class="pr-2"
              @keyup.enter="login"
            ></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-btn
              block
              round
              depressed
              class="normal-text pl-1 btn-continue"
              :color="!password ? 'info' : 'primary'"
              :class="{ 'btn-disabled': !password }"
              dark
              @click="login"
            >
              Continuar
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout class="mt-1">
          <span class="edit-btn" @click="forgotPassword(userProps.email)"
            >Esqueci minha senha</span
          >
        </v-layout>
      </div>
      <div v-else>
        <TwoFactor
          :login="{ email: userProps.email, password }"
          @login="login"
          @onCancel="twoFactor = false"
        />
      </div>
    </v-card>
    <v-card flat class="pa-3" v-if="signSteps.logged">
      <div class="login-section pa-3">
        <v-layout>
          <v-flex>
            <span class="login-title">Você entrou com o email:</span>
            <p class="mb-0">{{ userProps.email }}</p>
          </v-flex>
          <v-flex shrink>
            <span class="edit-btn" @click="logout">Alterar</span>
          </v-flex>
        </v-layout>
      </div>
    </v-card>
    <v-card flat class="pa-3" v-if="signSteps.step > 1 && signSteps.step < 4">
      <div class="login-section pa-3">
        <InfosForgotPassword />
      </div>
    </v-card>
  </div>
</template>

<script>
import InfosForgotPassword from './forms/InfosForgotPassword';
import { mapGetters, mapActions } from 'vuex';
import TwoFactor from './TwoFactor.vue';

export default {
  components: {
    InfosForgotPassword,
    TwoFactor,
  },
  data: () => ({
    password: null,
    show: false,
    passwordRules: [v => !!v || 'Campo obrigatório'],
    twoFactor: false,
  }),
  computed: {
    ...mapGetters({
      userProps: 'userProps',
      signSteps: 'signSteps',
    }),
  },
  methods: {
    ...mapActions({
      forgotPassword: 'forgotPassword',
    }),
    changeUser() {
      this.$store.dispatch('setCurrentStep', 3);
      this.$store.dispatch('setSignSteps', {
        logged: false,
        signForm: true,
        step: 0,
      });
      this.$store.dispatch('setUserProps', {
        selectedDocument: 'cpf',
        emailConfirmation: null,
        email: null,
        document: null,
        name: null,
        phone: null,
      });
    },
    async login(token) {
      let data = {
        username: this.userProps.email,
        password: this.password,
      };

      if (token && !token.isTrusted) {
        data.token = token;
      }

      const resp = await this.$store.dispatch('clientLogin', data);

      if (resp['2fa']) {
        this.twoFactor = true;
      } else {
        this.twoFactor = false;
      }
    },
    logout() {
      this.$store.dispatch('eraseClientToken');
      this.$store.dispatch('sendPostMessage', {
        open: true,
        logged: false,
        userToken: null,
      });
      this.$store.dispatch('setCurrentStep', 3);
      this.$store.dispatch('setSignSteps', {
        logged: false,
        signForm: true,
        step: 0,
      });
    },
  },
  mounted() {
    this.password = null;
  },
};
</script>

<style scoped>
.login-section {
  background-color: #f1f7fd;
}
.login-title {
  font-size: 18px;
  font-weight: 500;
  line-height: 23px;
}
.edit-btn {
  cursor: pointer;
  color: #1976d2;
  font-weight: 450;
}
.btn-continue {
  margin-top: 12px;
}
</style>
